module.exports = __webpack_public_path__ + "img/xp-tb-wheel.b7df53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb-wheel.png
// module id = cN7K
// module chunks = 38 43